import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";

export const getTasks = ({ churchId }) => {
  return axios.get(`/churches/${churchId}/tasks`);
};

export const useTasks = ({ churchId, config } = {}) => {
  return useQuery({
    ...config,
    queryKey: ["tasks", churchId],
    queryFn: () => getTasks({ churchId }),
    select: data => data.result
  });
};
